module.exports = __webpack_public_path__ + "img/sms-3-1.ca2368df.png";